/**
 * @generated SignedSource<<b87695af9bb19aaa0ff742e62a9819f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountConnectDetailFragment$data = {
  readonly type: string | null;
  readonly meetSubdomain: string;
  readonly businessNumber: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly " $fragmentType": "accountConnectDetailFragment";
};
export type accountConnectDetailFragment$key = {
  readonly " $data"?: accountConnectDetailFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountConnectDetailFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountConnectDetailFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetSubdomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "businessNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longitude",
      "storageKey": null
    }
  ],
  "type": "AccountDetailConnect",
  "abstractKey": null
};

(node as any).hash = "2e5347c66a2a2cc464999599361a641b";

export default node;
